export default __webpack_public_path__ + "static/media/webDeveloper.f1daafd1.gif";